"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constant = constant;
exports.hardcoded = hardcoded;
exports.unknown = exports.mixed = exports.undefined_ = exports.null_ = void 0;

var _debrief = require("debrief");

var _Result = require("lemons/Result");

/**
 * Decoder that only returns Ok for `null` inputs.  Err otherwise.
 */
var null_ = function null_(blob) {
  return blob === null ? (0, _Result.Ok)(blob) : (0, _Result.Err)((0, _debrief.annotate)(blob, 'Must be null'));
};
/**
 * Decoder that only returns Ok for `undefined` inputs.  Err otherwise.
 */


exports.null_ = null_;

var undefined_ = function undefined_(blob) {
  return blob === undefined ? (0, _Result.Ok)(blob) : (0, _Result.Err)((0, _debrief.annotate)(blob, 'Must be undefined'));
};
/**
 * Decoder that only returns Ok for the given value constant.  Err otherwise.
 */


exports.undefined_ = undefined_;

function constant(value) {
  return function (blob) {
    return blob === value ? (0, _Result.Ok)(value) : (0, _Result.Err)((0, _debrief.annotate)(blob, "Must be constant ".concat(String(value))));
  };
}
/**
 * Decoder that always returns Ok for the given hardcoded value, no matter what the input.
 */


function hardcoded(value) {
  return function (_) {
    return (0, _Result.Ok)(value);
  };
}
/**
 * Decoder that always returns Ok for the given hardcoded value, no matter what the input.
 */


var mixed = function mixed(blob) {
  return (0, _Result.Ok)(blob);
};
/**
 * Alias of mixed.
 */


exports.mixed = mixed;
var unknown = mixed;
exports.unknown = unknown;